module.exports = __webpack_public_path__ + "da55dafe8f0c7e077a0168397fc589cf.svg";